/** Money formatting for internal item and cost displays. */

import { formatUnitPrice } from "@forgepoint/shared";

const NO_AMOUNT = "—";

/**
 * Formats a decimal-string or numeric amount for display, keeping unit-cost
 * precision (two fraction digits, widening to three).
 * @param value - The amount to format, or null when absent
 * @returns The formatted amount, or an em dash when absent or unparseable
 */
export function formatMoney(value: string | number | null | undefined): string {
  if (value === null || value === undefined || value === "") {
    return NO_AMOUNT;
  }
  const amount = Number(value);
  return Number.isNaN(amount) ? NO_AMOUNT : formatUnitPrice(amount);
}
